import React, { useEffect, useState } from "react";
import { ModalGrayNotification, RowGap5 } from "./styles";
import { ContentTop16 } from "../../../../../components/ui/Content";
import {
  Body1,
  Body1PointerLink,
  Body2,
  Subhead2,
} from "../../../../../components/Font";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { InputElement } from "../../../../../ui/Input/Input";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import styled, { useTheme } from "styled-components";
import {
  clearPhoneConfirmationDelay,
  confirmByUserCallReset,
  ConfirmPhoneByFlashCall,
  ConfirmPhoneBySms,
  VerifyPhoneByUserCall,
} from "../slice";

import {
  LoaderContainer,
  LoaderEnum,
  MiniLoader,
} from "../../../../../ui/Loader/MiniLoader";
import { PhoneConfirmationWay } from "../../../../../enum/phoneConfirm";
import { cleanError, SubmitPhoneCode } from "../../../slice";

const MailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#007AFF"
      fillRule="evenodd"
      d="M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H4Zm3.586 8L3 7.414v9.172L7.586 12Zm12 6H4.414L9 13.414l.586.586a3.414 3.414 0 0 0 4.828 0l.586-.586L19.586 18ZM21 16.586V7.414L16.414 12 21 16.586ZM19.586 6H4.414L11 12.586a1.414 1.414 0 0 0 2 0L19.586 6Z"
      clipRule="evenodd"
    />
  </svg>
);

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#007AFF"
      d="M20.01 15.88c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57
          1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53
          0-.54-.45-.99-.99-.99H4.19c-.54 0-1.19.24-1.19.99 0 9.29 7.73 17.01 17.01 17.01.71
          0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99Z"
    />
  </svg>
);

const YellowCircle = () => (
  <RotateContainer>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        stroke="#FC832D"
        strokeLinecap="round"
        strokeWidth="2"
        d="M14.793 1.744A9.97 9.97 0 0 0 11 1C5.477 1 1 5.477 1 11s4.477 10 10 10 10-4.477 10-10c0-2.19-.703-4.214-1.897-5.86"
      />
    </svg>
  </RotateContainer>
);

const SuccessIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
  >
    <path
      fill="#16C67A"
      fillRule="evenodd"
      d="M2 11a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm-2 0C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0
         11Zm15.707-2.293a1 1 0 0 0-1.414-1.414L9.5 12.086l-1.793-1.793a1 1 0 1 0-1.414 1.414L9.5 14.914l6.207-6.207Z"
      clipRule="evenodd"
    />
  </svg>
);

const RotateContainer = styled.div`
  height: 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  animation: rotate 2s linear infinite;
`;

export const SmsConfirmation = () => {
  const { delay, phone, fetching } = useAppSelector(
    (state) => state.phoneConfirm,
  );
  const { error } = useAppSelector((state) => state.auth);
  const { t } = useTranslation();
  const Theme = useTheme();
  const dispatch = useAppDispatch();
  const [countdown, setCountdown] = useState(0);
  const [code, setCode] = useState("");

  const isFetching = Object.keys(fetching).length !== 0;

  useEffect(() => {
    if (delay) {
      setCountdown(delay);
    }
  }, [delay]);

  useEffect(() => {
    const count = () => {
      if (countdown > 0) {
        setCountdown(countdown - 1);
      } else {
        dispatch(clearPhoneConfirmationDelay());
      }
    };

    const timeout = setTimeout(count, 1000);
    return () => clearTimeout(timeout);
  }, [countdown]);

  const submit = () => {
    if (code.length === 6 && !isFetching && phone) {
      dispatch(
        SubmitPhoneCode({
          phone,
          code,
        }),
      );
    }
  };
  const resend = () => {
    setCode("");
    if (error["code"]) {
      dispatch(cleanError("code"));
    }
    if (phone) {
      dispatch(
        ConfirmPhoneBySms({
          phone_number: phone,
          confirmation_type_id: PhoneConfirmationWay.sms,
        }),
      );
    }
  };
  useEffect(submit, [code, isFetching]);

  return (
    <>
      {phone && (
        <ModalGrayNotification>
          <MailIcon />
          <RowGap5>
            <Body1>
              {t("passport.registrationForm.phoneConfirm.smsSentTo")}
            </Body1>
            <Body2>{phone}</Body2>
          </RowGap5>
        </ModalGrayNotification>
      )}
      <InputElement
        autofocus
        format={"###-###"}
        error={error["code"]}
        mask={"_"}
        disabled={fetching["VerifyPhoneBySms"]}
        placeholder={t("passport.registrationForm.inputCodeForm.title")}
        value={code}
        onChange={(value) => {
          setCode(value);
          if (error["code"]) {
            dispatch(cleanError("code"));
          }
        }}
        style={{ marginTop: "16px" }}
      />
      <ContentTop16>
        {fetching["ConfirmPhoneBySms"] || fetching["VerifyPhoneBySms"] ? (
          <LoaderContainer>
            <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small} />
          </LoaderContainer>
        ) : (
          <>
            {countdown ? (
              <Body1 color={Theme.color.secondary}>
                {t("passport.registrationForm.phoneConfirm.resendCode")} (
                {moment.utc(countdown * 1000).format("mm:ss")})
              </Body1>
            ) : (
              <Body1PointerLink onClick={resend}>
                {t("passport.registrationForm.phoneConfirm.resendCode")}
              </Body1PointerLink>
            )}
          </>
        )}
      </ContentTop16>
    </>
  );
};

export const FlashCallConfirmation = () => {
  const { delay, phone, fetching } = useAppSelector(
    (state) => state.phoneConfirm,
  );
  const { error } = useAppSelector((state) => state.auth);
  const { t } = useTranslation();
  const Theme = useTheme();
  const dispatch = useAppDispatch();
  const [countdown, setCountdown] = useState(0);
  const [code, setCode] = useState("");

  const isFetching = Object.keys(fetching).length !== 0;

  useEffect(() => {
    if (delay) {
      setCountdown(delay);
    }
  }, [delay]);

  useEffect(() => {
    const count = () => {
      if (countdown > 0) {
        setCountdown(countdown - 1);
      } else {
        dispatch(clearPhoneConfirmationDelay());
      }
    };

    const timeout = setTimeout(count, 1000);
    return () => clearTimeout(timeout);
  }, [countdown]);

  const submit = () => {
    if (code.length === 4 && !isFetching && phone) {
      dispatch(
        SubmitPhoneCode({
          phone,
          code,
        }),
      );
    }
  };
  const resend = () => {
    setCode("");
    if (error["code"]) {
      dispatch(cleanError("code"));
    }
    if (phone) {
      dispatch(
        ConfirmPhoneByFlashCall({
          phone_number: phone,
          confirmation_type_id: PhoneConfirmationWay.flashCall,
        }),
      );
    }
  };

  useEffect(submit, [code, isFetching]);

  return (
    <>
      {phone && (
        <ModalGrayNotification>
          <PhoneIcon />
          <RowGap5>
            <Body1 style={{ whiteSpace: "nowrap" }}>
              {t("passport.registrationForm.phoneConfirm.willBeCall")}
            </Body1>
            <Body2>{phone}</Body2>
          </RowGap5>
        </ModalGrayNotification>
      )}
      <InputElement
        autofocus
        format={"####"}
        error={error["code"]}
        mask={"_"}
        disabled={fetching["VerifyPhoneByFlashCall"]}
        placeholder={t("passport.registrationForm.inputCodeForm.title")}
        value={code}
        onChange={(value) => {
          setCode(value);
          if (error["code"]) {
            dispatch(cleanError("code"));
          }
        }}
        style={{ marginTop: "16px" }}
      />
      <ContentTop16>
        {fetching["ConfirmPhoneByFlashCall"] ||
        fetching["VerifyPhoneByFlashCall"] ? (
          <LoaderContainer>
            <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small} />
          </LoaderContainer>
        ) : (
          <>
            {countdown ? (
              <Body1 color={Theme.color.secondary}>
                {t("passport.registrationForm.phoneConfirm.resendCode")} (
                {moment.utc(countdown * 1000).format("mm:ss")})
              </Body1>
            ) : (
              <Body1PointerLink onClick={resend}>
                {t("passport.registrationForm.phoneConfirm.resendCode")}
              </Body1PointerLink>
            )}
          </>
        )}
        {}
      </ContentTop16>
    </>
  );
};

export const UserCallConfirmation = () => {
  const { phone, servicePhone, confirmedByUserCall, operation_id, delay } =
    useAppSelector((state) => state.phoneConfirm);
  const Theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [countdownDeadline, setCountdownDeadline] = useState(0);
  const deadline = useAppSelector((state) => state.phoneConfirm.deadline);
  const formattedPhone = servicePhone?.startsWith('+') ? servicePhone : "+"+ servicePhone;
  useEffect(() => {
    if (deadline) {
      setCountdownDeadline(delay || 0);
    }
  }, [deadline]);
  useEffect(() => {
    const count = () => {
      if (countdownDeadline > 0) {
        setCountdownDeadline(countdownDeadline - 1);
      } else {
        dispatch(clearPhoneConfirmationDelay());
      }
    };

    const timeout = setTimeout(count, 1000);
    return () => clearTimeout(timeout);
  }, [countdownDeadline]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (operation_id) dispatch(VerifyPhoneByUserCall({ operation_id }));
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [operation_id]);

  useEffect(() => {
    if (confirmedByUserCall && phone) {
      setTimeout(() => {
        dispatch(SubmitPhoneCode({ phone, code: null }));
        dispatch(confirmByUserCallReset());
      }, 5000);
    }
  }, [confirmedByUserCall, phone]);

  return (
    <>
      <Body1 color={Theme.color.secondary}>
        {t('passport.registrationForm.phoneConfirm.formWillBeUpdated')}
      </Body1>
      <ContentTop16 />
      {phone && (
        <ModalGrayNotification>
          <PhoneIcon />
          <RowGap5>
            <Body1>
              {t('passport.registrationForm.phoneConfirm.waitingForCall')}
            </Body1>
            <Body2>{phone}</Body2>
          </RowGap5>
        </ModalGrayNotification>
      )}

      <ContentTop16>
        <Body1>
          {t('passport.registrationForm.phoneConfirm.freeCallNumber')}
        </Body1>
        <ContentTop16>
          <Subhead2 color={Theme.color.indicator}>{formattedPhone}</Subhead2>
        </ContentTop16>
        <ContentTop16>
          {confirmedByUserCall ? (
            <YellowRow>
              <SuccessIcon />
              <Body1 color={'#16C67A'}>
                {t('passport.registrationForm.phoneConfirm.operationSuccess')}
              </Body1>
            </YellowRow>
          ) : (
            <YellowRow>
              <YellowCircle />
              <Body1 color={'#FC832D'}>
                {t('passport.registrationForm.phoneConfirm.processingCall')}
              </Body1>
            </YellowRow>
          )}
        </ContentTop16>
      </ContentTop16>
      {countdownDeadline ? (
        <ContentTop16 style={{ justifyContent: 'center', display: 'flex' }}>
          <Body1 color={Theme.color.secondary}>
            {t('passport.registrationForm.phoneConfirm.codeActive')} (
            {moment.utc(countdownDeadline * 1000).format('mm:ss')})
          </Body1>
        </ContentTop16>
      ) : (
        <ContentTop16 style={{ justifyContent: 'center', display: 'flex' }}>
          <Body1 color={Theme.color.danger}>
            {t('passport.registrationForm.phoneConfirm.codeActive')}{' '}
            {moment.utc(countdownDeadline * 1000).format('mm:ss')}
          </Body1>
        </ContentTop16>
      )}
    </>
  );
};

const YellowRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
